<template>
  <gj-popover lazy placement="bottom" width="220" v-model="visible" @show="show">
      <gj-operation-state-select
        width="220px"
        placeholder="请选择运营状态"
        v-model="form.operationStatus"
        :disabled="!$permission('listing:editOperationInfo')"
        >
        </gj-operation-state-select>
      <div style="text-align: right; margin: 20px 0 0;">
        <el-button size="mini" type="text" @click="visible = false" style="border: 1px solid #1F6EEF;height:26px">取消</el-button>
        <el-button type="primary" size="mini" @click="confirm" :loading="loading" style="height:26px">确定</el-button>
      </div>
    <i class="el-icon-edit" slot="reference" :disabled="false"></i>
  </gj-popover>
</template>

<script>
import {editOperationStatus} from "@/api/sale";
export default {
  name: 'edit-good-operation',
  props: {
    row: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      visible: false,
      loading: false,
      form: {
        operationStatus: null
      },
    };
  },
  methods: {
    // B08GKT75KG
    show() {
      this.form = {
        operationStatus: this.row.operationStatus
      };
    },
    confirm() {
      this.loading = true;
      const params = {
        listingId: this.row.id,
        operationStatus: this.form.operationStatus,
      };
      editOperationStatus(params)
        .then(() => {
          this.visible = false;
          this.$emit('editSucc');
        })
        .complete(() => (this.loading = false));
    },
  },
};
</script>
